module.exports = __webpack_public_path__ + "media/images/bg/mosaic/kimono-6d83deb26229edc1f8c8c97ee020ae7d.svg";